import { Box, Typography } from '@mui/material';
import { useField } from 'formik';

import DisplayCurrency from 'src/components/DisplayCurrency';
import { DEFAULT_BORDER } from 'src/constants';

interface ThumbnailCardProps {
    label: string;
    amount: number;
}

const ThumbnailCard = ({ label, amount }: ThumbnailCardProps) => {
    const [{ value: currencySymbol }] = useField('currencySymbol');

    return (
        <Box>
            <Box
                sx={{
                    textAlign: 'center',
                    backgroundColor: '#F39E4E',
                    color: '#fff',
                    padding: '10px',
                    borderRadius: '10px 10px 0 0',
                }}
            >
                <Typography sx={{ fontSize: '18px' }}>{label}</Typography>
            </Box>
            <Box
                sx={{
                    ...DEFAULT_BORDER,
                    display: 'flex',
                    justifyContent: 'center',
                    borderTop: 'none',
                    borderRadius: '0 0 10px 10px',
                    padding: '10px',
                }}
            >
                <DisplayCurrency
                    usersCurrency={currencySymbol}
                    currencyAmount={amount}
                    style={{
                        fontSize: '18px',
                    }}
                />
            </Box>
        </Box>
    );
};
export default ThumbnailCard;
